
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-requests/order/[orderUuid]",
      function () {
        return require("private-next-pages/customer-requests/order/[orderUuid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-requests/order/[orderUuid]"])
      });
    }
  